import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { DockReservedInterval } from 'contracts/DockReservedIntervals';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_DOCK_RESERVED_INTERVAL_',
  }
);

export interface FetchDockReservedIntervalState {
  data: DockReservedInterval | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchDockReservedIntervalRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: DockReservedInterval;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchDockReservedIntervalState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchDockReservedIntervalState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: FetchDockReservedIntervalState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: FetchDockReservedIntervalState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchDockReservedIntervalState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchDockReservedInterval = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchDockReservedIntervalTypes = Types;
export const FetchDockReservedIntervalActions = Creators;
